import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen';

// Padrões da onda 1 só em dev (P1): em produção a rota responde 404 e o chunk nem é pedido. A busca
// passa inteira: cada demonstração lê o seu pedaço com o schema gerado pelo `defineFilters`.
export const Route = createFileRoute('/dev/forms')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-forms-catalog'), 'FormsCatalog') : () => null,
});
